import { Component } from 'react'
import _ from 'lodash'
import moment from 'moment'
import clx from 'classnames'
import { Button, Tip } from '@vzmi/shp_shared_compo'
import { EMPTY_VALUE } from '../../../../../constants/globalTypes'
import {
  RadioGroupInputField,
  TextareaCountField,
  MenuSelectField
} from '../../../../Common/Form'
import {
  getDashboardDateTime
} from '../../../../../lib/MomentHelper'
import FormRow from '../../../../Common/NewDashboard/FormRow/FormRow'
import DateTimeRange from '../../../../Common/NewDashboard/DateTimeRange/DateTimeRange'
import {
  formDecorator,
  Field,
  FormValueSelector
} from '../../../../Common/forms'
import {
  removeNotNumberAndComma
} from '../../../../../lib/parser'
import { idsOnlyParser, ID_MAX_NUMBER } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import styles from './SearchForm.css'
import {
  LISTING_TYPE,
  LISTING_TYPE_OPTIONS
} from '../../constants/listing'

export const FIELD = {
  LISTING_TYPE: 'listingType',
  LISTING_IDS: 'listingIds',
  START_DATETIME: 'startDateTime'
}

export const LISTING_IDS_LIMIT = 50

export const validateListingIds = (values) => {
  const listingType = values[FIELD.LISTING_TYPE]
  const listingId = values[FIELD.LISTING_IDS]

  if (listingType === LISTING_TYPE.ALL) {
    return {}
  }

  if (_.isEmpty(listingId)) {
    return { [FIELD.LISTING_IDS]: '請輸入賣場編號' }
  }

  const listingIds = idsOnlyParser(listingId)
  if (_.size(listingIds) > LISTING_IDS_LIMIT) {
    return { [FIELD.LISTING_IDS]: `最多輸入${LISTING_IDS_LIMIT}筆` }
  }

  const isListingIdGreaterThanMaxSize = _.some(listingIds, id => id === ID_MAX_NUMBER)

  if (isListingIdGreaterThanMaxSize) {
    return { [FIELD.LISTING_IDS]: '賣場編號長度超過最大值，請重新檢查' }
  }

  return {}
}

const syncValidator = values => {
  let errors = {}
  errors = _.merge(errors, validateListingIds(values))
  return errors
}

export const INIT_VALUES = {
  [FIELD.LISTING_TYPE]: LISTING_TYPE.ALL,
  [FIELD.LISTING_IDS]: '',
  [FIELD.START_DATETIME]: ''
}

export const CONFIG = {
  form: 'REAL_TIME_DASHBOARD_FORM',
  validate: syncValidator,
  initialValues: INIT_VALUES
}

export const getCount = (props) => {
  const inputValue = _.get(props, 'input.value', '')
  const count = _.size(idsOnlyParser(inputValue))
  return count
}

/**
 * 產生此時間前24小時前 每小時的日期時間
 * @param {string} endDateTime 指定訖時間
 * @returns Object[]
 */
export const genStartDateTimeOptions = endDateTime => {
  const dateTimeArray = _.times(24, index =>
    moment(endDateTime)
      .subtract(index, 'hours')
      .subtract(59, 'minutes')
      .subtract(59, 'seconds')
  )
  return dateTimeArray
    .map(val => {
      const dashboardDateTime = getDashboardDateTime(val)
      return {
        value: dashboardDateTime,
        label: dashboardDateTime,
        moment: val
      }
    })
    .reverse()
}

class SearchForm extends Component {
  componentDidMount () {
    this.props.onFormInit(this.props)
  }

  onSubmit = (e) => {
    this.props.handleSubmit(e)
  }

  render () {
    const { datetimeRange: [startDateTime, endDateTime], startDateTimeOptions } = this.props
    return (
      <form onSubmit={this.onSubmit}>
        <FormRow
          label='時間區間'
          labelAlign='top'
          contentClassName={styles.dateTimeRangeWrapper}
        >
          <div className={styles.datetimeRangeArea}>
            {
              (startDateTime && endDateTime)
                ? (
                  <>
                    <Field
                      name={FIELD.START_DATETIME}
                      placeholder={startDateTimeOptions[0].label}
                      component={MenuSelectField}
                      className={styles.dateTimeDropdown}
                      options={startDateTimeOptions}
                      enableFilter={false}
                    />
                    <DateTimeRange className={styles.datetimeRange} />
                    {getDashboardDateTime(endDateTime)}
                  </>
                )
                : (
                  <span>
                    {EMPTY_VALUE}
                    <DateTimeRange className={styles.timeRange} />
                    {EMPTY_VALUE}
                  </span>
                )
            }
          </div>
          <Tip type='info'>
            以時為單位，統計過去24小時業績，每日07:00 - 23:00更新
          </Tip>
        </FormRow>
        <FormRow
          label='賣場'
          labelAlign='top'
        >
          <Field
            key={FIELD.LISTING_TYPE}
            name={FIELD.LISTING_TYPE}
            data-role={FIELD.LISTING_TYPE}
            className={styles.listingType}
            component={RadioGroupInputField}
            buttonStyle='outline'
            options={LISTING_TYPE_OPTIONS}
            onChange={this.props.onListingTypeChange}
          />
        </FormRow>
        <FormValueSelector fieldName={FIELD.LISTING_TYPE}>
          {listingType => {
            const isFieldVisible = listingType === LISTING_TYPE.ORDER
            return (
              <FormRow
                style={{ marginTop: 15 }}
                className={clx(
                  styles.listingIdRow,
                  { hidden: !isFieldVisible }
                )}
              >
                <Field
                  name={FIELD.LISTING_IDS}
                  data-role={FIELD.LISTING_IDS}
                  countLimit={LISTING_IDS_LIMIT}
                  customizeGetCount={getCount}
                  component={TextareaCountField}
                  className={styles.listingId}
                  placeholder={`請輸入賣場編號，以逗號或 ENTER 分隔，最多輸入 ${LISTING_IDS_LIMIT} 筆`}
                  parse={removeNotNumberAndComma}
                />
              </FormRow>
            )
          }}
        </FormValueSelector>
        <FormRow labelAlign='top'>
          <Button
            type='submit'
            data-role='search-btn'
            size='large'
            className={styles.searchBtn}
          >
            查詢
          </Button>
        </FormRow>
      </form>
    )
  }
}

const SearchFormWithDecorator = formDecorator(CONFIG)(SearchForm)

export default SearchFormWithDecorator
